<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4229_9292)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.714294 2.85715C0.714294 1.67368 1.67368 0.714294 2.85715 0.714294H17.1429C18.3263 0.714294 19.2857 1.67368 19.2857 2.85715V6.67921C19.2857 12.3823 15.6363 17.4456 10.2259 19.249C10.0793 19.298 9.92075 19.298 9.77414 19.249C4.36368 17.4456 0.714294 12.3823 0.714294 6.67921V2.85715ZM15.0866 6.42612C15.4796 5.98385 15.4399 5.30664 14.9976 4.91351C14.5553 4.52038 13.8781 4.56022 13.4849 5.00249L8.42561 10.6942L6.35715 9.14288C5.88377 8.78784 5.21219 8.88378 4.85715 9.35717C4.50211 9.83055 4.59805 10.5021 5.07144 10.8572L7.92858 13C8.37437 13.3344 9.00202 13.2712 9.37224 12.8547L15.0866 6.42612Z" fill="#7B8827"/>
</g>
<defs>
<clipPath id="clip0_4229_9292">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
